
import { Component, Vue } from "vue-property-decorator";
import OrderPane from "../components/order-pane.vue";
import DatePicker from "@/components/date-picker.vue";
import { apiReturnOrderList, apiTransferLogList } from "@/api/order";
import ExportData from "@/components/export-data/index.vue";
import { RequestPaging } from "@/utils/util";
import LsPagination from "@/components/ls-pagination.vue";
import { apiShopLists } from "@/api/shop";
@Component({
    components: {
        OrderPane,
        DatePicker,
        ExportData,
        LsPagination
    },
})
export default class ReturnOrder extends Vue {
    // S Data
    apiReturnOrderList = apiReturnOrderList;
    pager = new RequestPaging();
    loading = false
    form: any = {
        sn: "", //否	string	订单信息
        sid: "", //否	string	下单商户
        to_sid: "", //否	string	工厂商户
        start_time: "", //否	string	开始时间
        end_time: "", //否	string	结束时间
        status: "",
        settlement_status: 0
    };
    shop_lists: any[] = [];
    statusList = [
        { value: '', label: '全部' },
        { value: 0, label: '未进行' },
        { value: 1, label: '已执行' },
        { value: 2, label: '执行错误' },
        { value: 3, label: '订单取消' }
    ]
    settlementList = [
        { value: 0, label: '全部' },
        { value: 1, label: '已结算' },
        { value: 2, label: '待结算' },
        { value: 3, label: '待完成（未出库）' },
        { value: 4, label: '结算失败' }
    ]
    dialogVisible = false
    logList: any[] = []

    time: Array<object> = [];
    pickerOptions = {
        shortcuts: [{
            text: '最近一周',
            onClick(picker: any) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
            }
        },
        {
            text: '最近一个月',
            onClick(picker: any) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
            }
        },
        {
            text: '最近三个月',
            onClick(picker: any) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
            }
        }
        ]
    }
    // E Data

    // S Methods

    // 获取订单信息
    getShopList() {
        apiShopLists({ page_size: 9999 }).then((res) => {
            this.shop_lists = res.lists;
        });
    }
    getList(page?: number) {
        this.loading = true
        page && (this.pager.page = page);
        this.pager
            .request({
                callback: apiReturnOrderList,
                params: {
                    // order_status: status,
                    ...this.form,
                },
            })
            .then((res) => {
                this.loading = false
            });
    }
    splitTime() {
        if (this.time != null) {
            this.form.start_time = this.time[0]
            this.form.end_time = this.time[1]
        }
    }
    // 重置搜索
    reset() {
        Object.keys(this.form).map((key) => {
            this.$set(this.form, key, "");
        });
        this.getList();
    }

    showDialog(id: number) {
        this.dialogVisible = true
        apiTransferLogList({ id: id, page_size: 9999 }).then(res => {
            this.logList = res.lists
        })
    }

    // E Methods

    // S  life cycle

    created() {
        this.getShopList()
        // 获取订单信息
        this.getList();
    }

    // E life cycle
}
